import React, { useEffect } from 'react'
import { useRouter } from 'next/router'
import { useSelf } from 'components/providers/SelfProvider'

import Page from 'components/common/Page'
import colors from 'utility/colors'
import { SignInBlock } from 'components/common/blocks/SignInBlock'

const SignInPage = () => {
  let title = `Sign in`
  let description = `Sign in to view your portal`

  const router = useRouter()
  const { isSignedIn, user } = useSelf()

  useEffect(() => {
    if (isSignedIn && user?.baseSlug) {
      router.push(user?.baseSlug)
    }
  }, [router, isSignedIn])

  return (
    <Page
      title={title}
      description={description}
      footer
      fluid
      hideSignup
      footerBackground={`${colors.WHITE}`}
      paddingTop={50}
      backgroundColor={colors.WHITE}
    >
      <SignInBlock />
    </Page>
  )
}

export default SignInPage
